export const DnaKitStatus = Object.freeze([
  {
    text: 'Registered',
    value: 'USER_REGISTERED'
  },
  {
    text: 'Sample Collection',
    value: 'RECEIVED_BY_EOSTRE'
  },
  {
    text: 'Arrived at DNA Laboratory',
    value: 'KIT_ARRIVED_LAB'
  },
  {
    text: 'Report Generation',
    value: 'RESULT_OUT'
  }
]);

export const DnaKitCategory = Object.freeze([
  {
    text: 'Adult Standard',
    value: 'ADULT_STANDARD'
  },
  {
    text: 'Adult Premium',
    value: 'ADULT_PREMIUM'
  },
  {
    text: 'Kid Standard',
    value: 'KID_STANDARD'
  },
  {
    text: 'Kid Premium',
    value: 'KID_PREMIUM'
  }
]);
